<template>
    <div>
        <view-item v-if="!!item" :item="item" @success="alertSuccess" @delete-item="deleteType" @cancel="item = false"
            @error="showError"></view-item>

        <list-items v-else :items="items" :title="title" @show-item="showItem" ref="table">
            <import-form
            :subject="$translate('item_type')"
            v-model="importModal"
            @cancel="hideModal()"
            :fields="inventoryFields"
            :upload-record="uploadInventoryRecord"
            :isitemtype="isitemtype"
            settings-key-name="ItemTypeUploadKey"
          ></import-form>
          <div
          class="d-flex gap-1 gap-md-2 ps-3 mt-1 mt-md-0 align-self-baseline align-self-md-center master-item-button"
      >
          <b-button
          id="add-checkoff-btn"
          variant="blue-icon"
          v-b-tooltip.hover
          :title="$addLabel()"
          v-if="hasPermissionCreate"
         @click="item = {}"
          >
          <img src="@/assets/images/icon/gradient-add.svg" />
          </b-button>

          <b-button
          id="import-checkoff-item-btn"
          variant="blue-icon"
          v-b-tooltip.hover
          :title="$translate('import')"
          @click="openModel()"
          v-if="hasPermissionCreate"
        >
          <img src="@/assets/images/icon/import.svg" />
        </b-button>
        <b-button
        id="export-checkoff-item-btn"
        variant="blue-icon"
        v-b-tooltip.hover
        :title="$translate('export')"
        @click="export_workflow()"
        v-if="hasPermissionCreate"
      >
        <img src="@/assets/images/icon/export.svg" />
      </b-button>
      </div>
            <!-- <b-button block variant="primary" id="create-item-type-btn" v-if="hasPermissionCreate" @click="item = {}"><img v-b-tooltip.hover
                    :title="$addLabel()" src="@/assets/images/icon/blue-add.svg">
            </b-button> -->
        </list-items>
    </div>
</template>
<script>
import ListItems from './ListItems'
import ViewItem from './ViewItem'

import utilityMixins from '@/mixins/utilityMixins'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import importMixins from "@/mixins/importMixins";
import ImportForm from "@/components/ImportForm.vue";

const inventoryFields = [
  { name: "name", label: "name", required: true, type: "text" },

  {
    name: "description",
    label: "description",
    required: false,
    type: "text",
  },
  {
    name: "tax_rate",
    label: "tax_rate",
    required: true,
    type: "text",
  },
  {
    name: "uom",
    label: "uom",
    required: false,
    type: "text",
  },

  {
    name: "size_uom",
    label: "size_uom",
    required: false,
    type: "text",
  },

  {
    name: "is_task",
    label: "is_task",
    required: false,
    type: "text",
  },

  {
    name: "is_order_item",
    label: "is_order_item",
    required: false,
    type: "text",
  },
  {
    name: "is_discount",
    label: "is_discount",
    required: false,
    type: "text",
  },


  {
    name: "item_type_group",
    label: "item_type_group",
    required: false,
    type: "text",
  },


];
export default {
    name: 'ItemTypes',
    components: {
        ListItems,
        ViewItem,
        ImportForm
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins,importMixins],
    data: () => {
        return {
            item: null,
            title: 'Item&nbsp;type',
            isitemtype : 'yes',
            importModal : false,
            inventoryFields,
        }
    },
    mounted() {
        this.$store.dispatch("masterItem/unit_of_measures");
        let page = 0;
        let query = "";
         this.$store.dispatch('item_type_group/fetch', {
                    query,
                    page,
                })
        this.doSearch()
    },
    computed: {
        componentName() { return this.$translate('item_type') },
        items() {
            const items = this.$store.state.itemType.items
            console.log('items', items)
            return items.map(x => {
                x.is_task = !!x.is_task
                x.is_order_item = !!x.is_order_item
                //x.is_asset = !!x.is_asset
                x.is_discount = !!x.is_discount
                return x
            })
        },
    },

    methods: {
        async doSearch() {
            await this.$store.dispatch('itemType/fetchAll')
        },

        showItem(id) {
            const item = this.items.find(x => x.id === id)
            this.item = { ...item }
        },

        alertSuccess(action, message) {
            console.log(message, "sucesss")
            this.genericToast(
                this.componentName,
                this.$translate(action.toLowerCase()),
                'success',
                message
            )
            //this.doToast('Success', `Item ${action}!`, 'success')
            this.item = null
            this.doSearch()
        },

        showError(error) {
            // const interror = 'Internal Server Error'
            // if (interror == error.message) {
            this.genericToast(
                this.componentName,
                this.$translate('error'),
                'danger',
                `${error.message}`
            )
            // }
        },
        async uploadInventoryRecord(
            dataRecord,
            statusRecord,
            { check, message, field },
            statuses,
            setLoading
            ) {
            try {
                // Initialize the param object
                let param = {};

                // Loop through inventoryFields to map values from dataRecord
                inventoryFields.forEach(({ name }) => {
                let value = dataRecord[name];

                // Clean up and validate values for each field
                value = typeof value === "string" ? value.trim() : value || 0;

                // Add the value to the param object
                param[name] = value;
                });

                // Log the param object for debugging
                console.log({ param });

                // Dispatch the upload action
                const res = await this.$store.dispatch("itemType/upload", param);
                this.tableLoading = true;
                await this.$store.dispatch('itemType/fetchAll');
                this.tableLoading = false;

                // Set status to COMPLETE if the upload is successful
                statusRecord.status = statuses.COMPLETE;
            } catch (err) {
                console.error("Error", err);

                // Handle error and set status to ERROR
                statusRecord.error_list = typeof err.message == "string"
                ? [["error", [err.message]]]
                : Object.entries(err.message);
                statusRecord.status = statuses.ERROR;
            } finally {
                // Final loading state cleanup
                setLoading(false);
            }
            },
            openModel(){
     
            this.importModal = true;   
            },
            async export_workflow(){
            
                this.tableLoading = true
                await this.$store.dispatch('itemType/ExportExcel')
                this.tableLoading = false
            }

    },
}
</script>
<style></style>
